var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{on:{"change":_vm.change},model:{value:(_vm.isRateActive),callback:function ($$v) {_vm.isRateActive=$$v},expression:"isRateActive"}})}
var staticRenderFns = []

export { render, staticRenderFns }